import React, { createRef, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import StatusIcon from '../../icons/statusIcon';
import styles from './deliveryTime.scss';
import ModalWrapper from '../../modalwrapper/modalWrapper';
import { IInjectedProps } from '../../../types';
import classNames from 'classnames';
import TabNavigationHelper from '../../../helper/tabNavigationHelper';

export enum AvailabilityState {
    InStock,
    SoonInStock,
}
const buttonRef = createRef<HTMLElement>();
const DeliveryTime = inject('store')(
    observer(({ store }: IInjectedProps) => {
        const tabNavigation = TabNavigationHelper.instance;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const localization = store!.localization;
        const [modalOpen, setModalOpen] = React.useState(false);
        const showHalfWidth = store?.dataStore.contextData.portal.includes('DE') && !store.showKioskLayout;

        useEffect(() => {
            tabNavigation.setFocusAtt(buttonRef.current);
        }, [buttonRef])



        const handleDeliveryTimeClick = React.useCallback((open) => {
            setModalOpen(open);
            open ? store?.scrollLock.lock() : store?.scrollLock.unlock();
            open ? store?.hideEsAppButton() : store?.showEsAppButton();
            if (!open) {
                if (buttonRef.current)
                    window.shell.tabNav.focus(buttonRef.current);
            }
        }, []);

        const label= store?.articleSoldOut ? store?.localization.generalL10n.articleNotAvailable
            : store?.orderModuleStore.deliveryTimeString;

        return (
            <div
                className={classNames(
                    styles.delivery_time_container,
                    showHalfWidth ? styles.half_width : styles.full_width
                )}
                title={label}
            >
                <StatusIcon statusColor={
                    store?.articleSoldOut ? store?.orderModuleStore.soldOutArticleStatusColor
                        : store?.orderModuleStore.deliveryTimeStatusColor} />
                <span
                    data-testid='delivery_time'
                    className={classNames(styles.delivery_time_text, { [styles.isGlobal]: store?.isGlobal })}
                    onClick={!store?.isGlobal ? () => handleDeliveryTimeClick(true) : undefined}
                    ref={buttonRef}>
                    {label}
                </span>
                <ModalWrapper
                    isOpen={modalOpen}
                    title={localization.generalL10n.deliveryTime}
                    onClose={() => handleDeliveryTimeClick(false)}
                    content={
                        <div
                            className={styles.delivery_time_modal_content}
                            dangerouslySetInnerHTML={{ __html: localization.generalL10n.deliveryTimeText }}
                        />
                    }
                />
            </div>
        );
    })
);

export default DeliveryTime;
